import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { addCrudCases } from '../../store/addCrudCases';
import { taskThunks, updateTaskStatus } from './taskThunks';
import type { TaskState, TaskTab } from './taskTypes';

const initialState: TaskState = {
  items: [],
  byId: {},
  currentItem: null,
  status: 'idle',
  error: null,
  activeTab: 'all',
  filters: {},
  totalCount: 0,
};

export const taskSlice = createSlice({
  name: 'tasks',
  initialState,
  reducers: {
    setActiveTab(state, action: PayloadAction<TaskTab>) {
      state.activeTab = action.payload;
    },
    setTaskFilters(state, action: PayloadAction<Partial<TaskState['filters']>>) {
      state.filters = { ...state.filters, ...action.payload };
    },
    clearTaskFilters(state) {
      state.filters = {};
    },
  },
  extraReducers: (builder) => {
    addCrudCases(builder, taskThunks, (t) => t.taskId);
    // Patch di stato via endpoint dedicato: aggiorna byId/items/currentItem
    // come fa l'update generico ma senza disturbare lo `status` (loading)
    // dello slice — la transizione e' una micro-operazione tipicamente
    // invisibile a livello di UI.
    builder.addCase(updateTaskStatus.fulfilled, (state, action) => {
      const updated = action.payload;
      state.byId[updated.taskId] = updated;
      const idx = state.items.findIndex((t) => t.taskId === updated.taskId);
      if (idx !== -1) state.items[idx] = updated;
      if (state.currentItem?.taskId === updated.taskId) state.currentItem = updated;
    });
  },
});

export const { setActiveTab, setTaskFilters, clearTaskFilters } = taskSlice.actions;
export const taskReducer = taskSlice.reducer;
